/**
 * Small shared accessors for RoomPlan-style elements (walls, stair flights,
 * floors, openings, furniture) — the `category` field, which RoomPlan stores
 * as either a plain string or a single-key object (`{ stairs: {} }`), and
 * vertical (Y-axis) extent derived from `center.y` + `dimensions.y`.
 *
 * Previously duplicated (with drifting variants — one dropped optional
 * chaining, one returned `null` instead of `undefined` for an unrecognized
 * category) across `recoverStairFlights.js`, `reconstructLanding.js`,
 * `capWallsUnderStairs.js`, and `shared-lib/loft/detectLandings.js`. None of
 * those call sites depend on the `null` vs `undefined` distinction — every
 * one only ever compares the result with `===`.
 */

/** RoomPlan category, whether stored as a string or a single-key object. */
function categoryOf(o) {
  return typeof o?.category === 'string'
    ? o.category
    : Object.keys(o?.category || {})[0];
}

/** Bottom Y of an element with `center.y` + `dimensions.y`. */
function bottomOf(el) {
  return el.center.y - el.dimensions.y / 2;
}

/** Top Y of an element with `center.y` + `dimensions.y`. */
function topOf(el) {
  return el.center.y + el.dimensions.y / 2;
}

module.exports = { categoryOf, bottomOf, topOf };
